export interface MccGroupListResponse {
  id: string
  group: string
}

export class MccGroupListModel {
  public id: string
  public group: string

  public constructor(r: MccGroupListResponse) {
    this.id = r.id
    this.group = r.group
  }
}
